import { render, staticRenderFns } from "./Septic.vue?vue&type=template&id=1e10f808&scoped=true&"
import script from "./Septic.vue?vue&type=script&lang=js&"
export * from "./Septic.vue?vue&type=script&lang=js&"
import style0 from "./Septic.vue?vue&type=style&index=0&id=1e10f808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e10f808",
  null
  
)

export default component.exports